import { apiFetch, parseApiResponse } from '../../../utils/apiClient';

const request = async (path, options = {}) => parseApiResponse(await apiFetch(path, { signal: options.signal }));

export const getPlanningProjects = async (options = {}) => {
  const rows = await request('/api/projects', options);
  return (Array.isArray(rows) ? rows : []).map((project) => ({
    ...project,
    displayLabel: [project.code, project.name || project.label].filter(Boolean).join(' — '),
  }));
};

export const getPlanningInterventions = async (options = {}) => {
  const response = await request('/api/interventions?pageSize=100', options);
  return (Array.isArray(response) ? response : response?.items || []).map((intervention) => ({
    ...intervention,
    displayLabel: [intervention.code, intervention.name].filter(Boolean).join(' — '),
  }));
};

export const getPlanningTasks = async (options = {}) => {
  const rows = await request('/api/tasks', options);
  return (Array.isArray(rows) ? rows : []).map((task) => ({ ...task, displayLabel: task.title || `Tâche ${task.id}` }));
};

export const getPlanningClients = async (options = {}) => {
  const rows = await request('/api/partners', options);
  return (Array.isArray(rows) ? rows : []).map((client) => ({
    ...client,
    displayLabel: client.socialReason || client.name || client.legalName || `Client ${client.id}`,
  }));
};

export const getPlanningDeliverables = async (projectId, options = {}) => {
  if (!projectId) return [];
  const rows = await request(`/api/module/lda/project/${encodeURIComponent(projectId)}`, options);
  return (Array.isArray(rows) ? rows : []).map((line) => ({
    ...line,
    displayLabel: [line.codeGed, line.title].filter(Boolean).join(' — '),
  }));
};

export const filterPlanningTasks = (tasks, { projectId }) => (tasks || []).filter((task) => {
  if (projectId && String(task.projectId) !== String(projectId)) return false;
  return Boolean(projectId) || !task.projectId;
});
